var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class RemoteAuthenticationTypeHandler {
    constructor() {
        this.authentications = ['BASIC_AUTH', 'CIDR_RANGES'];
        this.getFormattedSuperSelectOptions = (entities) => {
            return [
                {
                    value: this.authentications[0],
                    inputDisplay: 'Basic Authentication'
                },
                {
                    value: this.authentications[1],
                    inputDisplay: 'CIDR Ranges'
                }
            ];
        };
    }
    listEntity() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                resolve(this.authentications);
            });
        });
    }
}
